import getUSDollar from "utils/getUSDollar";
import styles from "./styles.module.scss";

const CustomYAxisTick = ({ y, payload }) => {
  return (
    <g transform={`translate(0,${y})`}>
      <text
        x={0}
        y={0}
        textAnchor="start"
        dominantBaseline="middle"
        fill="var(--gray01)"
        className={styles["custom-y-axis-tick"]}
      >
        {getUSDollar(payload.value)}
      </text>
    </g>
  );
};

export default CustomYAxisTick;
